import React from 'react';
import {Link} from 'react-router-dom';
import {
  Collapse,
  Navbar,
  NavbarToggler,
  NavbarBrand,
  Nav,
  NavItem,
  NavLink
} from 'reactstrap';

class Header extends React.Component{
  constructor(props){
    super(props);
    this.toggle = this.toggle.bind(this);
    this.state = {
      isOpen:false
    };
  }
  toggle(){
    this.setState({
      isOpen: !this.state.isOpen
    });
  }
  render(){
    const pathName = window.location.pathname;
    return(
      <div>
        <Navbar expand="sm">
          <div className="container-fluid">
            <NavbarBrand tag={Link} to="/"><img src="/assets/logo.png" alt="GongIdeas" /></NavbarBrand>
            <NavbarToggler onClick={this.toggle} />
            <Collapse isOpen={this.state.isOpen} navbar>
              <Nav className="ml-auto" navbar>
                <NavItem>
                  <NavLink className={(pathName === '/')?'active':''} tag={Link} to="/">หน้าแรก</NavLink>
                </NavItem>
                <NavItem>
                  <NavLink className={(~pathName.indexOf('portfolio'))?'active':''} tag={Link} to="/portfolios">ผลงาน</NavLink>
                </NavItem>
                <NavItem>
                  <NavLink className={(pathName === '/contact')?'active':''} tag={Link} to="/contact">ติดต่อเรา</NavLink>
                </NavItem>
              </Nav>
            </Collapse>
          </div>
        </Navbar>
      </div>
    );
  }
}

export default Header;


// WEBPACK FOOTER //
// ./src/components/Header.js